import EnvironmentBanner from '../headers/EnvironmentBanner';
import { ENVIRONMENTS } from '../../services/exports/Constants';
import React, { ReactElement } from 'react';

interface Props {
  children: ReactElement;
  header?: ReactElement;
}

const PageLayout = (props: Props): JSX.Element => {
  const { children, header } = props;

  const showEnvBanner: boolean = import.meta.env.VITE_MODE !== ENVIRONMENTS.PROD;

  return (
    <>
      <div id="page-header">
        {showEnvBanner && <EnvironmentBanner />}
        {header && header}
      </div>
      <div>{children}</div>
    </>
  );
};

export default PageLayout;
